import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Location} from './Location';

const manager = new I18nManager({locale: 'en-CA'});

export function LocationSection(props) {
  return (
    <I18nContext.Provider value={manager}>
      <Location {...props} />
    </I18nContext.Provider>
  );
}

export default renderReact('Location', LocationSection);
